import { Badge, Box, ButtonGroup, Card, CardBody, Divider, Flex, Heading, Icon, Stack, Text } from '@chakra-ui/react'
import React, { useContext } from 'react'
import { FaUser, FaUsers, FaCalendarAlt, FaUserTag, FaCode } from 'react-icons/fa';
import { GetProjectTypeOptionByValue } from '../../components/options/GetOptionByValue'
import LinkButton from '../../components/custom/LinkButton'
import DeleteButton from '../../components/custom/DeleteButton'
import { convertToYYYYMMDD } from '../../components/utils/dateTimeUtil'
import { UserInfoContext } from '../../provider/UserInfoProvider'
import { UseConstant } from '../../libraries/UseConstant'

export default function SingleProject({project, searchedTechnologyIds = []}) {
    const { constant } = UseConstant();
    const { userInfo } = useContext(UserInfoContext);
    const isAdmin = userInfo?.user_type === constant.USER_TYPE_ADMIN || userInfo?.user_type === constant.USER_TYPE_USER;

    const getDetailsButtonUrl = () => {
        if (isAdmin) { 
            return `/project/${project.id}`; 
        }
        return `/my-project/${project.id}`;
    }

    // Check if a technology is in the searched list
    const isTechnologyMatched = (technologyId) => {
        return searchedTechnologyIds.length > 0 && 
            searchedTechnologyIds.includes(technologyId);
    }

    return (
        <Card
            backgroundColor={"orange.100"}
            boxShadow="lg"
            borderRadius="lg"
            p={5}
            maxW="sm"
            _hover={{ transform: "scale(1.05)", transition: "0.3s ease-in-out" }}
        >
            <CardBody>
                <Flex justify="space-between" align="center" mb={3}>
                    <Heading size="md">{project.project_title}</Heading>
                    <Badge colorScheme={project.is_on_going === "1" ? "green" : "red"}>
                        {project.is_on_going === "1" ? "進行中" : "完了"}
                    </Badge>
                </Flex>

                <Text fontSize="sm" color="gray.500" mb={2}>
                    部署: {project.department}
                </Text>

                <Badge colorScheme="blue" mb={4}>
                    {GetProjectTypeOptionByValue(project.type)}
                </Badge>

                <Divider my={2} />

                <Stack spacing={3}>
                    {isAdmin && (
                        <Flex align="center">
                            <Icon as={FaUser} mr={2} />
                            <Text><strong>登録者:</strong> {project.user_project.user.name}</Text>
                        </Flex>
                    )}

                    <Flex align="center">
                        <Icon as={FaUsers} mr={2} />
                        <Text><strong>チーム人数:</strong> {project.no_of_people}名</Text>
                    </Flex>

                    <Flex align="center">
                        <Icon as={FaCalendarAlt} mr={2} />
                        <Text>
                        <strong>期間: </strong> 
                        {convertToYYYYMMDD(project.start_date)} 〜 {project.is_on_going === "1" ? "現在" : convertToYYYYMMDD(project.end_date)}
                        </Text>
                    </Flex>

                    <Flex align="center">
                        <Icon as={FaUserTag} mr={2} />
                        <strong>役割:&nbsp;</strong> 
                        {Array.isArray(project.role_users) && project.role_users.length > 0 ? project.role_users.map((role_user, index) => (
                            <Text key={index}>{role_user.role?.role}</Text>
                        )) : '情報なし'}
                    </Flex>

                    <Box>
                        <Flex align="center" mb={2}>
                            <Icon as={FaCode} mr={2} />
                            <strong>技術:</strong>
                        </Flex>
                        <Flex flexWrap="wrap" gap={2}>
                            {Array.isArray(project.project_technologies) && project.project_technologies.length > 0 
                                ? project.project_technologies.map((project_technology, index) => {
                                    const isMatched = isTechnologyMatched(project_technology.technology.id);
                                    
                                    return (
                                        <Badge 
                                            key={index} 
                                            colorScheme={isMatched ? "green" : "blue"}
                                            px={2} 
                                            py={1}
                                            fontWeight={isMatched ? "bold" : "normal"}
                                            borderWidth={isMatched ? "2px" : "0px"}
                                            borderColor={isMatched ? "green.500" : "transparent"}
                                        >
                                            {project_technology.technology.technology}
                                        </Badge>
                                    );
                                })
                                : <Text>情報なし</Text>
                            }
                        </Flex>
                    </Box>

                    <Text><strong>内容:</strong> {project.details}</Text>
                </Stack>

                <Divider my={2} />

                <ButtonGroup 
                    spacing={4} 
                    mt={4}
                    flexDirection={{ base: "column", sm: "row", md: "row" }}
                    gap={2}
                    w="100%"
                >
                    <LinkButton buttonText={'詳細'} buttonUrl={getDetailsButtonUrl()} variant='solid' />
                    {/* <LinkButton buttonText={'編集'} buttonUrl={'#'} colorScheme='blue' variant='solid' /> */}
                    <DeleteButton colorScheme="red" handleDelete={() => {}} id={project?.id}/>
                </ButtonGroup>
            </CardBody>
        </Card>
    )
}
